import { ROUTES } from '@/config/const';

type Menu = {
  href: string;
  label: string;
  active: boolean;
};

export function getMenuList(pathname: string): Menu[] {
  return [
    {
      href: ROUTES.dashboard,
      label: 'Dashboard',
      active: pathname.includes(ROUTES.dashboard),
    },
    {
      href: ROUTES.filters,
      label: 'Filters',
      active: pathname.includes(ROUTES.filters),
    },
    {
      href: ROUTES.discord,
      label: 'Discord',
      active: pathname.includes(ROUTES.discord),
    },
    {
      href: ROUTES.slack,
      label: 'Slack',
      active: pathname.includes(ROUTES.slack),
    },
  ];
}
